'use client';

import SiteChatWidget from './components/chat/SiteChatWidget';
import { ThemeProvider } from './components/ThemeProvider';
import { SidebarCollapseProvider } from './components/SidebarCollapseProvider';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <SidebarCollapseProvider>
        {children}
        <SiteChatWidget />
      </SidebarCollapseProvider>
    </ThemeProvider>
  );
}
